import { Instance, cast, types } from "mobx-state-tree";

import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { RoleResponse } from "../../api-models/response/RoleResponse";
import { Role } from "./Role";
import { UserRoles } from "../../generated/Users";

const UserRolesModel = types.model({
  isDefaultEmployeeStatus: types.optional(types.boolean, false),
  userRoles: types.array(types.frozen<Role>()),
});

export const UserRolesStorageModel = types
  .compose(UserRolesModel, StorageModel)
  .named("UserRolesStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: RoleResponse[]) {
        self.userRoles = cast(response.map((r) => new Role(r)));
      },
      setIsDefaultEmployeeStatus(isDefault: boolean) {
        self.isDefaultEmployeeStatus = isDefault;
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("users_roles");
      return endpoint;
    },
    get isLoading() {
      return !self.userRoles.length;
    },
    get rolesForCurrentEmploymentStatus() {
      if (self.isDefaultEmployeeStatus) return self.userRoles;
      return self.userRoles.filter((role) => role.id !== UserRoles.Admin);
    },
  }));

export type UserRolesStorage = Instance<typeof UserRolesStorageModel>;
